import axios from 'axios';

const initialState = {
  isLoading: false,
  isFormDataLoading: false,
  isSuccess: false,
  errorMessage: '',
  description: '',
  formData: {},
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setIsFormDataLoading(state, value) {
      state.isFormDataLoading = value;
    },
    setIsSuccess(state, value) {
      state.isSuccess = value;
    },
    setErrorMessage(state, value) {
      state.errorMessage = value;
    },
    setDescription(state, data) {
      state.description = `By submitting this form and checking this box, you agree to receive promotional messages from <strong>${data.business_name}</strong>. This agreement isn't a condition of any purchase. Message frequency varies, and data rates may apply. Reply STOP to opt out. <strong>${data.customer_care}</strong> View <a href="${data.privacy_policy_url}" target="_blank">${data.privacy_policy_text}</a>.`;
    },
    setFormData(state, value) {
      state.formData = value;
    }
  },
  getters: {
    hasErrorMessage(state) {
      return state.errorMessage !== '';
    }
  },
  actions: {
    async submitOptInForm({ commit }, payload) {
      commit('setIsLoading', true);
      commit('setIsSuccess', false);
      commit('setErrorMessage', '');
      try {
        const { token } = payload;
        delete payload.token;

        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const data = {
          first_name: payload.firstName,
          phone: payload.phone,
          description: payload.description,
          url: payload.url,
        };
        
        await axios.post(`${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/alt-auth/opt-in/form`, data, { skipAuthInterceptor: true, headers });
        commit('setIsSuccess', true);
      } catch (error) {
        console.error('Error submitting opt-in form', error);
        commit('setErrorMessage', error.data && error.data.error ? error.data.error : 'An error occurred');
        commit('setIsSuccess', false);
      } finally {
        commit('setIsLoading', false);
      }
    },
    async getData({ commit }, token) {
      commit('setIsFormDataLoading', true);
      try {
        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get(
          `${process.env.VUE_APP_COMMUNICATIONS_API_BASE_URL}/sms/alt-auth/opt-in/form/data`,
          { skipAuthInterceptor: true, headers },
        );
        commit('setDescription', response.data);
        commit('setFormData', response.data);
      } catch (error) {
        console.error(error);
      } finally {
        commit('setIsFormDataLoading', false);
      }
    },
  },
};
